import { render, staticRenderFns } from "./PersistResponsavelSaraivaView.vue?vue&type=template&id=4276dc93&"
import script from "./PersistResponsavelSaraivaView.vue?vue&type=script&lang=ts&"
export * from "./PersistResponsavelSaraivaView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports